import { tv } from '@change/ds-utils';

const variants = {
	orientation: {
		horizontal: null,
		vertical: null,
	},
	isMobile: {
		false: null,
		true: null,
	},
};

export const header = tv({
	base: 'bg-background-base col-span-full flex w-full max-w-full items-center justify-center overflow-hidden',
	compoundVariants: [
		{
			class: 'p-4',
			orientation: 'vertical',
			isMobile: true,
		},
		{
			class: 'px-4 py-4',
			orientation: 'horizontal',
			isMobile: true,
		},
		{
			class: 'max-h-[72px] px-7 py-3',
			isMobile: false,
		},
	],
	variants,
});

export const container = tv({
	base: 'flex w-full flex-shrink-0 grow basis-0 items-center sm:max-w-full md:max-w-[1216px]',
	compoundVariants: [
		{
			class: 'flex-col gap-3',
			orientation: 'vertical',
			isMobile: true,
		},
		{
			class: 'flex-row gap-3',
			orientation: 'horizontal',
			isMobile: true,
		},
		{
			class: 'flex-row gap-4',
			isMobile: false,
		},
	],
	variants,
});
